import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import AppShell from "../layouts/AppShell";
import { appModules } from "../components/global";
import Switch from "react-switch";
import { GET, POST, PUT, DELETE, loading, alert } from "../components/CustomComponent";

const PayslipModal = ({ show, onHide, onSave }) => {
  const [isActive, setIsActive] = useState(true);

  return (
    <Modal show={show} onHide={onHide} centered>
    <Modal.Header closeButton className="bg-light border-0">
      <Modal.Title className="fw-bold h5 mb-0">สร้างสลิปเงินเดือน (Bulk)</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <form className="row g-3">
        <div className="col-md-12">
          <label className="form-label">รอบเงินเดือน</label>
          <input type="month" className="form-control" defaultValue="2026-03" />
        </div>
        <div className="col-md-12">
          <label className="form-label">แผนก / กลุ่มพนักงาน</label>
          <select className="form-select">
            <option>สร้างสลิปทุกคน</option>
            <option>เฉพาะ IT & Engineering</option>
            <option>เฉพาะ HR</option>
          </select>
        </div>
        <div className="col-12">
          <div className="form-check">
            <input className="form-check-input" type="checkbox" id="sendEmail" defaultChecked />
            <label className="form-check-label text-secondary" htmlFor="sendEmail">
              ส่งอีเมลแจ้งเตือนพนักงานอัตโนมัติเมื่อสร้างเสร็จ
            </label>
          </div>
        </div>
        <div className="col-12">
          <label className="form-label mb-0 pointer" htmlFor="isActiveOvertime">เปิดใช้งาน (Active)</label><br/>
          <Switch checked={isActive} onChange={setIsActive} onColor="#0c75e6" height={24} width={48} id="isActiveOvertime" />
        </div>
      </form>
    </Modal.Body>
    <Modal.Footer className="bg-light border-0">
      <button type="button" className="btn btn-secondary" onClick={onHide}>ยกเลิก</button>
      <button type="button" className="btn btn-primary" onClick={() => onSave({ isActive })}>เริ่มสร้างสลิป</button>
    </Modal.Footer>
  </Modal>
  );
};

export default function Payslips() {
  const { title, description } = appModules["payslips"];
  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState([]);

  const summaryCards = [
    { label: "สลิปที่สร้างแล้ว (รอบปัจจุบัน)", value: "142", color: "#0c76e5" },
    { label: "รอสร้างสลิป", value: "0", color: "#2fd5e4" },
    { label: "พนักงานเปิดดูแล้ว", value: "98", color: "#48bb78" },
  ];

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const GetData = async () => {
    loading(true);
    let body = {};
    let result = await GET("v1/admin/payslips", body);
    if (result?.status) {
      setData(result.data || []);
    }
    loading(false);
  };

  useEffect(() => {
    GetData();
  }, []);

  const CreateUpdate = async (formData) => {
    if (
      await alert("", "info", "ยืนยัน", "ยืนยันการบันทึกข้อมูลหรือไม่?", "ยืนยัน", "ยกเลิก")
    ) {
      loading(true);
      let uid = formData?.uid;
      let body = { ...formData };

      let result = !uid
        ? await POST("v1/admin/payslips", body)
        : await PUT("v1/admin/payslips/" + uid, body);
        
      if (result?.status === true) {
        alert("", "success", "สำเร็จ", "ทำรายการสำเร็จแล้ว");
        GetData();
        handleCloseModal();
      } else {
        alert("", "warning", "แจ้งเตือน", result?.message || "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      }
      loading(false);
    }
  };

  const DeleteData = async (id) => {
    if (
      await alert("", "warning", "ลบรายการ", "ต้องการลบรายการนี้ใช่หรือไม่?", "ยืนยัน", "ยกเลิก")
    ) {
      loading(true);
      let result = await DELETE("v1/admin/payslips/" + id, null);
      if (result?.status) {
        alert("", "success", "สำเร็จ", "ทำรายการสำเร็จแล้ว");
        GetData();
      }
      loading(false);
    }
  };

  return (
    <AppShell title={title} description={description}>
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-3">
        <div className="d-flex gap-2 filters-mobile-stack">
          <select className="form-select" style={{ width: '220px', borderRadius: '12px' }}>
            <option>รอบ: มีนาคม 2026</option>
          </select>
        </div>
        <button onClick={() => handleOpenModal()} className="btn btn-primary px-4">
          สร้างสลิป (Bulk)
        </button>
      </div>

      <div className="row g-3 mb-4">
        {summaryCards.map((item) => (
          <div key={item.label} className="col-12 col-md-4">
            <div
              className="h-100 rounded-4 p-4 d-flex flex-column justify-content-center"
              style={{
                background: "linear-gradient(180deg, #ffffff 0%, #f2f9ff 100%)",
                border: "1px solid rgba(18, 125, 255, 0.10)",
                boxShadow: "0 14px 28px rgba(12, 118, 229, 0.06)",
              }}
            >
              <p className="small text-uppercase text-secondary mb-1">{item.label}</p>
              <h2 className="h2 mb-0 fw-bold" style={{ color: item.color }}>{item.value}</h2>
            </div>
          </div>
        ))}
      </div>

      <div
        className="rounded-4 p-3 bg-white"
        style={{
          border: "1px solid rgba(18, 125, 255, 0.10)",
          boxShadow: "0 4px 12px rgba(12, 118, 229, 0.04)",
        }}
      >
        <h5 className="mb-4 fw-semibold text-dark">คลังสลิปเงินเดือน</h5>
        <div className="table-responsive table-mobile-cards">
          <table className="table table-hover align-middle">
            <thead className="table-light">
              <tr>
                <th className="text-secondary fw-medium rounded-start">ชื่อพนักงาน</th>
                <th className="text-secondary fw-medium text-end">ยอดสุทธิ (Net Pay)</th>
                <th className="text-secondary fw-medium">วันที่สร้างเอกสาร</th>
                <th className="text-secondary fw-medium text-center rounded-end">ดาวน์โหลด</th>
              </tr>
            </thead>
            <tbody>
              {[1, 2, 3, 4, 5].map((i) => (
                <tr key={i}>
                  <td data-label="ชื่อพนักงาน"><div className="fw-medium">พนักงาน ทดสอบ {i}</div></td>
                  <td data-label="ยอดสุทธิ (Net Pay)" className="text-end">30,750.00</td>
                  <td data-label="วันที่สร้างเอกสาร">25 มี.ค. 2026</td>
                  <td data-label="ดาวน์โหลด" className="text-center">
                    <button className="btn btn-sm btn-outline-primary rounded-3 px-3"><i className="bi bi-file-earmark-pdf"></i> PDF</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <PayslipModal show={showModal} onHide={handleCloseModal} onSave={CreateUpdate} />
    </AppShell>
  );
}